export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/flyer_distribution.fb7b093.svg";